import { v4 as uuid } from 'uuid';
import XLSX from 'xlsx';

import { Order, DefineColumn } from './types';

interface ExportToXLSXOptions {
  excludeValues?: string[];
  fileTitle?: string;
  subject?: 'Sample';
  author?: 'Meritt';
  createDate?: Date;
  dataTransform?: (value: any) => number | string;
}

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T): number {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key,
): (
  a: {
    [key in Key]: number | string | string[] | number[];
  },
  b: {
    [key in Key]: number | string | string[] | number[];
  },
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort<T>(
  array: T[],
  comparator: (a: T, b: T) => number,
): T[] {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

export function exportToXLSX(
  defineColumns: DefineColumn[] | Partial<DefineColumn>[],
  tableData: any[],
  options: ExportToXLSXOptions = {
    fileTitle: 'Table Export',
    subject: 'Sample',
    author: 'Meritt',
    createDate: new Date(),
    excludeValues: [],
  },
  filenamePrefix?: string,
): void {
  const sufix = uuid().replace(/-/gi, '_');
  const excludeValues = options.excludeValues
    ? [...options.excludeValues, 'id', 'type']
    : ['id', 'type'];
  const filteredDefineColumns = defineColumns.filter(
    column => !excludeValues.includes((column as DefineColumn).id),
  );
  const columns = filteredDefineColumns.map(column => column.label);

  const data: any = [];

  tableData.forEach(item => {
    const newItem = options.dataTransform ? options.dataTransform(item) : item;

    const newData = filteredDefineColumns.map(
      defineColumn => newItem[defineColumn.id as string],
    );

    data.push(newData);
  });

  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: options.fileTitle,
    Subject: options.subject,
    Author: options.author,
    CreatedDate: options.createDate,
  };
  const ws = XLSX.utils.aoa_to_sheet([columns, ...data]);

  XLSX.utils.book_append_sheet(wb, ws);
  XLSX.writeFile(wb, `${filenamePrefix || 'data'}_${sufix}.xlsx`);
}
